import clsx from 'clsx';
import React from 'react';

import { Theme } from '@interfaces/global';

const projects = [
  {
    name: 'Generative AI',
    redText: 'Database',
  },
  {
    name: 'Creator Economy',
    redText: 'Database',
  },
  {
    name: 'AI Chip',
    redText: 'Database',
  },
  {
    name: 'Enterprise Tech',
    redText: 'Powerlist',
  },
];

interface ProjectProps {
  className?: string;
  theme?: Theme;
}

const Projects = ({ theme = Theme.Dark, className }: ProjectProps) => {
  return (
    <div
      className={clsx(
        'mt-24 w-full border-0 border-t border-solid border-pro-gold pt-24',
        className
      )}
    >
      <h3 className="m-0 text-center font-suisse-intl-mono text-overline-lg text-pro-gold">
        Pro Databases (Samples)
      </h3>
      <div className="mt-32 flex flex-wrap items-center justify-center gap-48 sm:justify-between sm:gap-0">
        {projects.map(({ name, redText }) => (
          <p
            key={name}
            className={clsx(
              'm-0 text-center font-suisse-screen text-headline-xxs font-light sm:text-headline-xs',
              {
                'text-white': theme === Theme.Dark,
                'text-black': theme === Theme.Light,
              }
            )}
          >
            {name} <span className="block text-primary-magenta">{redText}</span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default Projects;
